module.exports = __webpack_public_path__ + "img/login_slogan_fr@2x.db79939e.png";